import 'pickadate/lib/picker';
import 'pickadate/lib/picker.date';
import 'pickadate/lib/picker.time';
import 'pickadate/lib/legacy';

export default function () {
    $(function () {
        datePicker();
    });
}

export function datePicker() {
    const $datePicker = $('.sl-js-datepicker');
    const $datepickerLang = $datePicker.data('lang');
    if ($datepickerLang !== 'en_EN') {
        require(`pickadate/lib/translations/${$datepickerLang}.js`);
    }

    // Documentation: http://amsul.ca/pickadate.js/api.htm#picker

    // use each here to prevent bug when reading attributes
    $.each($datePicker, function () {
        const format = $(this).attr('data-date-format');
        const that = this;
        let $picker = $(this).pickadate({
            selectYears: 180,
            selectMonths: true,
            format: format,
            formatSubmit: format
        }).pickadate('picker');

        // fix rendering issue on close
        $picker.on({
            open: function () {
                $(that).siblings('.picker').show();
            },
            close: function () {
                $(that).siblings('.picker').hide();
            }
        });
        // disable activation on focus
        $(this).off('focus')
    });

    $('.sl-js-clear-datepicker').on('click', function () {
        const picker = $(this).prevAll('.sl-js-datepicker').pickadate('picker');
        picker.clear();
    });
}